import {setSmoothScroll} from "./general";

document.addEventListener('DOMContentLoaded', () => {
  const YANDEX_CAPTCHA = 'yandex-captcha';
  const GOOGLE_RECAPTCHA = 'recaptcha';
  const instances = document.querySelectorAll('[data-vue]');

  if (!instances) return;

  const resizeText = () => {
    const textarea = document.querySelector('textarea');

    if (!textarea) return;

    const collapse = textarea.closest('.collapse');

    textarea.addEventListener('keyup', () => {
      if (textarea.scrollTop > 0) {
        textarea.style.height = textarea.scrollHeight + "px";
      }

      if (collapse) {
        collapse.style.maxHeight = collapse.scrollHeight + "px";
      }
    });
  };

  window.forms = [];

  const initialize = (instance) => {
    instance.classList.remove('loading');

    const request = {
      data: {
        data: {
          service: instance.dataset.service
        },
        smoothScroll: {
          target: '#request-form',
        }
      }
    };

    const mixins = [];
    if (instance.dataset.vue === 'request') {
      Vue.use(VueMask.VueMaskPlugin);
      mixins.push(request);
    }

    const form = new Vue({
      el: instance,
      mixins: mixins,
      data: {
        data: {},
        lang: '',
        submitURL: '',
        submitted: false,
        state: '',
        error: false,
        captcha: '',
        yandexCaptchaId: null
      },
      mounted: function () {
        this.submitURL = this.$el.action;
        this.lang = document.documentElement.lang;
        this.captcha = this.$el.getAttribute('data-captcha');
        this.captcha === YANDEX_CAPTCHA ? this.initializeCaptcha() : '';
      },
      methods: {
        submit() {
          if(this.captcha === YANDEX_CAPTCHA) {
            this.checkCaptcha();
          } else if(this.captcha === GOOGLE_RECAPTCHA) {
            this.checkReCaptcha()
          } else {
            this.submitForm();
          }
        },

        async submitForm() {
          const CAPTCHA_ERROR = 'CAPTCHA_ERROR';
          const LANGUAGE_RU = 'ru';
          const CAPTCHA_ERROR_TEXT = this.lang !== LANGUAGE_RU ? 'Error: The captcha secret key is not correct' : 'Ошибка: секретный ключ капчи не верен';
          const data = this.data;
          const self = this;

          self.submitted = true;
          self.error = false;

          try {
            const response = await fetch(this.submitURL, {
              method: 'POST',
              body: JSON.stringify(data)
            });
            const responseData = await response.json();

            this.submitted = responseData.success;
            this.error = !responseData.success;
            this.state = responseData.state;
            if (responseData.state === CAPTCHA_ERROR) {
              console.error(CAPTCHA_ERROR_TEXT);
            }
          } catch (err) {
            console.error(err);
            this.error = true;
            this.state = 'SAVE_ERROR';
          }
        },

        initializeCaptcha () {
          if (!window.smartCaptcha || this.yandexCaptchaId !== null) {
            return;
          }
          const captchaId = 'captcha-container-' + this.$el.dataset.vue;
          const captchaContainer = document.createElement('div');
          captchaContainer.id = captchaId;
          this.$el.appendChild(captchaContainer);

          this.yandexCaptchaId = window.smartCaptcha.render(captchaId, {
            sitekey: window.captchaPublicKey,
            invisible: true,
            callback: this.captchaCallback,
          });
        },

        captchaCallback(token) {
          this.data.captchaResponse = (token) ? token : '';
          if (this.data.captchaResponse !== '') {
            this.submitForm();
          }
        },

        checkCaptcha() {
          if (this.yandexCaptchaId !== null) {
            window.smartCaptcha.execute(this.yandexCaptchaId);
          }
        },

        checkReCaptcha() {
          if ('grecaptcha' in window) {
            grecaptcha.execute(window.captchaPublicKey, {action: 'submit'}).then((token) => {
              this.data.captchaResponse = (token) ? token : '';
              this.submitForm();
            });
          }
        }
      }
    });
    window.forms.push(form);
  };

  instances.forEach((instance) => initialize(instance));
  resizeText();
});
